var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 2,
    r: 2,
    fill: "#ABB2BF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 16.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 16.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 16.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 16.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 16.75,
    r: 2,
    fill: "#ABB2BF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 31.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 31.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 31.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 31.5,
    r: 2,
    fill: "#ABB2BF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 46.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 46.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 46.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 46.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 46.25,
    r: 2,
    fill: "#ABB2BF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 61,
    r: 2,
    fill: "#ABB2BF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 61,
    r: 2,
    fill: "#ABB2BF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 61,
    r: 2,
    fill: "#ABB2BF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.25,
    cy: 61,
    r: 2,
    fill: "#ABB2BF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 2,
    fill: "#ABB2BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame28);
export default __webpack_public_path__ + "static/media/Frame28.712e4ca731fd973ed289041f934a3877.svg";
export { ForwardRef as ReactComponent };